import { render, staticRenderFns } from "./ValidationErrorMessages.vue?vue&type=template&id=39cd95b4&scoped=true"
import script from "./ValidationErrorMessages.vue?vue&type=script&lang=js"
export * from "./ValidationErrorMessages.vue?vue&type=script&lang=js"
import style0 from "./ValidationErrorMessages.vue?vue&type=style&index=0&id=39cd95b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd95b4",
  null
  
)

export default component.exports